"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../gen-src/Localize");
exports.EmptyTimeSeries = function () {
    return (React.createElement("div", { className: containerStyle },
        React.createElement("p", { style: messageStyle }, Localize_1.Messages.timelineUnavailable())));
};
var containerStyle = typestyle_1.style({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: widgets_1.TabStyles.Sizing.BorderWidth,
    borderStyle: 'solid',
    borderColor: 'rgb(216, 216, 216)',
    height: '100%',
});
var messageStyle = {
    margin: '16px',
    fontWeight: 'normal',
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
    color: widgets_1.TabStyles.Colors.F8,
};
//# sourceMappingURL=EmptyTimeSeries.js.map